import React, { useEffect, useRef, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import { useLocation } from 'react-router-dom';
import { io } from "socket.io-client";
import QRCode from "qrcode";

function Exam() {
  const location = useLocation();
  var exam = location.state;
  const Course_Id = exam.Course_Id;

  const [enableEdit,setEnableEdit]=useState(false);
  const [enableEdit1,setEnableEdit1]=useState(false);
  const [resultAvailable,setResultAvailable]=useState(exam.results_available);

  const [newStart,setNewStart]=useState(exam.start);
  const [newEnd,setNewEnd]=useState(exam.end);

  const [showOptions,setShowOptions]=useState(false);

  const [allResults,setAllResults]=useState([]);

  const [courseStudents,setCourseStudents]=useState([]);

  const [socket, setSocket] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [messSent, setMessSent] = useState(0);
  const [ressRemain, setRessRemain] = useState(0);
  const [jobId, setJobId] = useState(null);
  const jobIdRef = useRef(null);
  const [isSendingMessages, setIsSendingMessages] = useState(false);


  useEffect(()=>{
    if(showOptions==2){
      getAllResults();
    }
  },[showOptions])

  useEffect(()=>{
    if(Course_Id){
      getAllCourseStudent();
    }
  },[Course_Id])

  useEffect(() => {
    const centerId = "11111111";
    const newSocket = io('https://whatsapp.genuisweb.com',
      {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      }
    );
    setSocket(newSocket);
    
    // معالجة الأحداث
    // const handleQrCode = (data) => {
    //     QRCode.toDataURL(data.qr)
    //       .then(url => setQrCode(url))
    //       .catch(console.error);
    // };

    const handleWhatsappReady = (data) => {
        alert('✅ تم ربط الواتساب بنجاح');
        setQrCode(null);
    };

    const handleStartSend = (data) => {
        setJobId(data.jobId);
        jobIdRef.current = data.jobId;
        setRessRemain(data.total);
    };

    const handleWhatsappUpdate = (data) =>{
      setMessSent(data.sent);
      setRessRemain(data.remaining)
    }


    newSocket.on("connect", () => {
        console.log("Connected:", newSocket.id);
        console.log(centerId);
        newSocket.emit('startWhatsApp', { companyId: centerId });
    });

    newSocket.on('connect_error', (error) => {
      console.error('Connection Error:', error);
    });

    newSocket.on('disconnect', (reason) => {
      console.log('Disconnected:', reason);
      if (reason === 'io server disconnect') {
        // manually reconnect if server kicked us off
        socket.connect();
      }
    });

    newSocket.on('accountDeleted', ()=>{
      alert("تم حذف الاكونت بنجاح")
    });

    newSocket.on('deleteAccountError', ()=>{
      alert("تعذر حذف الاكونت")
    });

    newSocket.on('bulkMessagesStarted', handleStartSend);
    // newSocket.on('qrCode', handleQrCode);
    newSocket.on('whatsappReady', handleWhatsappReady);
    newSocket.on('bulkMessagesUpdate', handleWhatsappUpdate);


    // التنظيف عند فك التثبيت
    return () => {
      // newSocket.off('qrCode', handleQrCode);
      newSocket.off('whatsappReady', handleWhatsappReady);
      newSocket.off('bulkMessagesStarted', handleStartSend);
      newSocket.off('bulkMessagesUpdate', handleWhatsappUpdate);
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    jobIdRef.current = jobId;
  }, [jobId]);


  const dateStart = new Date(exam.start);
  const dateEnd = new Date(exam.end);
  const options = {
    year: 'numeric',
    month: 'long', 
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true 
  };
  const readableDateStart = dateStart.toLocaleString('en-US', options);
  const readableDateEnd = dateEnd.toLocaleString('en-US', options);

  const handleResult =()=>{
    if(resultAvailable){
      senddata(`teacher/exam/results_unavailable/${exam._id}`,{}, "PATCH").then((res) => {
        if (res.status !== 200) {
            alert("تأكد من الاتصال بالانترنت");
        } else {
          setResultAvailable(false)
        }
    });
    }else{
      senddata(`teacher/exam/results_available/${exam._id}`,{}, "PATCH").then((res) => {
        if (res.status !== 200) {
            alert("تأكد من الاتصال بالانترنت");
        } else {
          setResultAvailable(true)
        }
    });
    }
  }

  const getAllResults =()=>{
    senddata(`teacher/exam/exam_results/${exam._id}`,{}, "GET").then((res) => {
      if (res.status !== 200) {
          alert("تأكد من الاتصال بالانترنت");
      } else {
        if(Course_Id && courseStudents.length){
          const updatedResults = courseStudents.map((student) => {
            const studentResult = res.data.find(
              (result) => result.student_Id === student._id
            );

            if (studentResult) {
              return {
                ...studentResult,
                parent_number: student.parentPhoneNumber,
                exists: true, // flag to sort later
              };
            }

            return {
              student_id: student._id,
              student_name: student.FirstName + " " + student.LastName,
              parent_number: student.parentPhoneNumber,
              result: "--",
              totalmark: "--",
              correctanswer: "--",
              wronganswer: "--",
              exists: false,
            };
          });

          updatedResults.sort((a, b) => {
            if (a.exists && !b.exists) return -1;
            if (!a.exists && b.exists) return 1;

            if (a.exists && b.exists) {
              return (b.result || 0) - (a.result || 0);
            }

            return 0;
          });

          setAllResults(updatedResults);
          return;
        }
        setAllResults(res.data)
      }
  });
  }

  const getAllCourseStudent =()=>{
    senddata(`course/getStudentsInCourse/${Course_Id}`,{}, "GET").then((res) => {
      if (res.status !== 200) {
          alert("تأكد من الاتصال بالانترنت");
      } else {
        setCourseStudents(res.data);
      }
  });
  }

  const printList = () => {
    let printContent = `
      <html>
        <head>
          <title>نتائج الامتحان</title>
          <style>
            body { font-family: Arial, sans-serif; direction: rtl; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #e9ad03; padding: 8px; text-align: center; }
            th { background: #f9e5a3; }
          </style>
        </head>
        <body>
          <h2 style="text-align:center;">نتائج الامتحان</h2>
          <table>
            <thead>
              <tr>
                <th>الرقم</th>
                <th>الاسم</th>
                <th>رقم ولي الامر</th>
                <th>الدرجة</th>
                <th>النسبة</th>
                <th>الاجابات الصحيحة</th>
                <th>الاجابات الخاطئة</th>
              </tr>
            </thead>
            <tbody>
    `;

    allResults.forEach((result, index) => {
      const percentage = result.exists
        ? ((result.result / result.totalmark) * 100).toFixed(2) + " %"
        : "غائب";

      printContent += `
        <tr>
          <td>${index + 1}</td>
          <td>${result.student_name}</td>
          <td>${result.parent_number}</td>
          <td>${result.result} / ${result.totalmark}</td>
          <td>${percentage}</td>
          <td>${result.correctanswer}</td>
          <td>${result.wronganswer}</td>
        </tr>
      `;
    });

    printContent += `
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  // 25/9
const sendResultsWhats = () => {
  if (!socket || isSendingMessages) return;

  setIsSendingMessages(true);

  const clientId = "11111111";

  if (!allResults.length) {
    alert("❌ لا يوجد طلاب لإرسال الرسائل إليهم");
    setIsSendingMessages(false);
    return;
  }

  // 👇 Ask for exam name and teacher name
  const examName = prompt("📘 من فضلك أدخل اسم الامتحان:");
  const teacherName = prompt("👨‍🏫 من فضلك أدخل اسم المعلم:");
  
  if (!examName || !teacherName) {
    alert("⚠️ يجب إدخال اسم الامتحان واسم المعلم قبل الإرسال.");
    setIsSendingMessages(false);
    return;
  }

  const messages = allResults.map(student => {
    const { student_name, parent_number, result, totalmark, exists } = student;

    // 👇 نص الرسالة حسب حالة exists
    let message;
    if (exists) {
      message = 
`👋 عزيزي ولي الأمر،

نود إعلامك بنتيجة الطالب **${student_name}** في امتحان **${examName}** مع المعلم **${teacherName}**. 🎓

📊 الدرجة: ${result} من ${totalmark}

💬 فضلاً أرسل أي رسالة للتأكيد على استلامك.`;
    } else {
      message = 
`👋 عزيزي ولي الأمر،

نود إعلامك بأن الطالب **${student_name}** لم يتقدم لأداء امتحان **${examName}** مع المعلم **${teacherName}**. ❌`;
    }

    return {
      number: parent_number.startsWith('2') ? parent_number : `2${parent_number}`,
      message
    };
  });

  // إرسال طلب الإرسال الجماعي عبر السوكيت
  socket.emit('sendBulkMessages', {
    companyId: clientId,
    data: messages
  });
};



  const editTime =()=>{
    const data = {
      start:newStart,
      end:newEnd
    }
    if (newStart&&newEnd){
      senddata(`teacher/exam/edit_exam/${exam._id}`,data, "PATCH").then((res) => {
        if (res.status !== 200) {
            alert("تأكد من الاتصال بالانترنت");
        } else {
          // setAllResults(res.data)
          alert("تم تعديل الوقت");
          exam.start=newStart;
          exam.end=newEnd;
        }
    });
    }
  }

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-[600px] '>
      <div className='headers '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      <div className='flex flex-col items-center'>
          <h2 className='border-b-2 border-[#e9ad03]'>تفاصيل الامتحان</h2>
          <div className='grid grid-cols-2  w-[60%] mt-8'>
              {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none'  /> : <p> {exam.title=="exercise"?"تدريب":exam.title=="exerciseinvideo"?"تدريب فيديو":exam.title=="single_exam"?"امتحان عام":exam.title }</p>}
              <p className='ml-auto'>: العنوان </p>
          </div>
          <div className='grid grid-cols-2  w-[60%] mt-4'>
              {enableEdit1?
              <input 
                type="datetime-local"
                value={newStart}
                onChange={(e) => setNewStart(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
              />
              : <p>{exam.start=="unlimited"?"مفتوح":readableDateStart}</p>}
              <p className='ml-auto'>: البداية</p>
          </div>
          <div className='grid grid-cols-2  w-[60%] mt-4'>
              {enableEdit1?
              <input 
                type="datetime-local"
                value={newEnd}
                onChange={(e) => setNewEnd(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
              />
              :<p>{exam.end=="unlimited"?"مفتوح":readableDateEnd}</p>}
              <p className='ml-auto'>: النهاية</p>
          </div>
          <div className='grid grid-cols-2  w-[60%] mt-6'>
              <p onClick={handleResult} className={`px-7 py-1 w-fit rounded-full cursor-pointer ${resultAvailable ? "bg-[#e9ad03]" : "bg-[#da0000]"}`} >{resultAvailable?" متاح":"غير متاح"}</p> 
              <p className='ml-auto'>: اتاحة النتيجة </p>
          </div>
      </div>

      {/* edit time */}
      
      {!(exam.end=="unlimited") &&<div className='grid grid-cols-2 gap-2 w-[70%] ml-auto mr-auto mt-10'>
          {enableEdit1?<p onClick={editTime} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto' > حفظ</p>:<p></p>}
          <p onClick={()=>{setEnableEdit1(!enableEdit1)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableEdit1?"عدم التعديل":"تعديل "}</p> 
      </div>}

      <div className='flex flex-row justify-around  py-2 min-w-full mt-12 '>
          <p onClick={()=>{setShowOptions(1)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==1?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> الاسئلة  </p> 
          <p onClick={()=>{setShowOptions(2)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==2?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> النتيجة </p> 
      </div>

      {showOptions==1&&exam.Questions.length&&
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] '>
            {
              exam.Questions?.map((question,key)=>{
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                    {question.img!="empty" && <div className=' grid grid-cols-1 rever gap-4'>
                      <img src={question.img} className='w-full mb-4 ' />
                    </div>}
                    <div className='p-3'>

                    <p className=' text-center text-[#e9ad03]'>{"السؤال"+" " +key} </p>
                        <p dir='rtl' > 👈 {question.question}</p>
                        {/* choice */}
                        {question.role=="choice"&&<p className=' text-center text-[#e9ad03]'>الاختيارات</p>}
                        {question.role=="choice"&&<>
                        <p className='mr-4' dir='rtl' >1- {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' >2- {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' >3- {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' >4- {question.answer_4}</p>
                        </>}
                        {/* correct */}
                        {question.role=="correct"&&<p className=' text-center text-[#e9ad03]'>الاجابة صحيحة</p>}
                        {question.role=="correct"&&<>
                        <p className='mr-4' dir='rtl' >{question.answer_1}</p>
                        </>}
                        {/* text */}
                        {question.role=="text"&&<p className=' text-center text-[#e9ad03]'>الاجابات المحتملة للقطعة</p>}
                        {question.role=="text"&&<>
                        <p className='mr-4' dir='rtl' > {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_4}</p>
                        </>}
                        {/* dialogue */}
                        {question.role=="dialogue"&&<p className=' text-center text-[#e9ad03]'>تكملة المحادثة</p>}
                        {
                          question.role=="dialogue" && question?.dialoguecompletionSpaces.length && question?.dialoguecompletionSpaces?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : </p>
                              <>
                                {item.length&&item?.map((answer)=>{
                                   return(<p className='mr-4' dir='rtl' > {answer} </p>)
                                })}
                              </>
                            </>
                          )
                          })
                        }
                        {/* complete */}
                        {question.role=="complete"&&<p className=' text-center text-[#e9ad03]'>التكملة الصحيحة</p>}
                        {
                          question.role=="complete" && question?.correctcomplete.length && question?.correctcomplete?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : {item} </p>
                            </>
                          )
                          })
                        }


                      <div className=' grid grid-cols-2 rever gap-4'>
                        {/* choice */}
                        {question.role=="choice"&&<p>{question.correctChoice=="answer_1"? "A":question.correctChoice=="answer_2"?"B":question.correctChoice=="answer_3"?"C":question.correctChoice=="answer_4"?"d":""} الاجابة الصحيحة</p>}
                        {/* bolean */}
                        {question.role=="boolean"&&<p>{question.correctBoolean=="answer_1"?"الاجابة صحيحة":"الاجابة خاطئة"}</p>}
                        <p>{question.mark} : الدرجة</p>
                      </div>

                    </div>
                  </div>
                )
              })
            }
          </div>
          }
          {/* results */}
          {showOptions==2&&allResults.length&&
          (
          // <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] '>
              <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>الرقم</div>
                  <div className='text-base w-[150px] text-center'>الاسم </div>
                  <div className='text-base w-[150px] text-center'>رقم ولي الامر </div>
                  <div className='text-base w-[150px] text-center'>الدرجة </div>
                  <div className='text-base w-[150px] text-center'>النسبة </div>
                  <div className='text-base w-[150px] text-center'>المدة </div>
                  <div className='text-base w-[150px] text-center'>الاجابات الصحيحة </div>
                  <div className='text-base w-[150px] text-center'>الاجابات الخاطئة </div>
                </div>
            {
              allResults?.map((result,index)=>{
                return(
                      <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={index}> 
                        <div className='text-base w-[150px] text-center'>{index+1} - </div>
                        <div className='text-base w-[150px] text-center'>{result.student_name}</div>
                        <div className='text-base w-[150px] text-center'>{result.parent_number}</div>
                        <div className='text-base w-[150px] text-center'>{result.result} / {result.totalmark} </div>
                        <div className='text-base w-[150px] text-center'>{result.exists? (result.result/result.totalmark*100).toFixed(2) + " %" :"غائب" } </div>
                        <div className='text-base w-[150px] text-center'>{result.timeConsume} دقيقة</div>
                        <div className='text-base w-[150px] text-center'>{result.correctanswer }</div>
                        <div className='text-base w-[150px] text-center'>{result.wronganswer } </div>
                    </div>
                )
              })
            }
          </div>)
          }
          {
            showOptions==2 && allResults.length && <div className='flex flex-row mt-10'>
              <p onClick={printList} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer hover:opacity-70 m-10'>تنزيل pdf</p>
              <p onClick={sendResultsWhats} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer hover:opacity-70 m-10'>ارسال الدرجات واتساب</p>
            </div>
          }
{/* 
          {qrCode && (
            <div className="mt-4">
              <p className="text-center">امسح الكود من تطبيق واتساب</p>
              <img 
                src={qrCode} 
                alt="QR Code" 
                className="mx-auto mt-2 w-48 h-48" 
              />
            </div>
        )}
  */}
    </div>
  )
}

export default Exam
